import { useScope, brandColorVar } from '@/context/ScopeContext';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import TESTIDS from '@/constants/testIds';

export function ScopeSwitcher() {
    const { brands, accountsForBrand, brandId, setBrandId, accountId, setAccountId } =
        useScope();

    return (
        <div className="flex items-center gap-2">
            <Select
                value={brandId || '__all__'}
                onValueChange={(v) => setBrandId(v === '__all__' ? null : v)}
            >
                <SelectTrigger
                    className="h-9 w-[200px] font-mono text-xs"
                    data-testid={TESTIDS.scopeSwitcherBrand}
                >
                    <SelectValue placeholder="All brands" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="__all__">All brands</SelectItem>
                    {brands.map((b) => (
                        <SelectItem key={b.id} value={b.id}>
                            <span
                                className="mr-2 inline-block h-2 w-2 rounded-full align-middle"
                                style={{ backgroundColor: `hsl(${brandColorVar(b.color_slot)})` }}
                            />
                            {b.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Select
                value={accountId || '__all__'}
                onValueChange={(v) => setAccountId(v === '__all__' ? null : v)}
            >
                <SelectTrigger
                    className="h-9 w-[220px] font-mono text-xs"
                    data-testid={TESTIDS.scopeSwitcherAccount}
                >
                    <SelectValue placeholder="All accounts" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="__all__">All accounts</SelectItem>
                    {accountsForBrand.map((a) => (
                        <SelectItem key={a.id} value={a.id}>
                            @{a.handle}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
